import { useEffect, useState } from "react";
import { Users, CreditCard, FlaskConical, PhoneCall, Clock, CalendarCheck, MessageSquare, TrendingUp, Bot, UserPlus, Loader2 } from "lucide-react";
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip, Legend } from "recharts";
import { adminApi } from "@/lib/adminApi";
import { StatCard, CHART_COLORS } from "@/components/admin/_shared";

export default function AdminOverview() {
  const [d, setD] = useState(null);
  useEffect(() => { adminApi.get("/admin/overview").then((r) => setD(r.data)).catch(() => {}); }, []);
  if (!d) return <div className="flex justify-center py-20"><Loader2 className="h-6 w-6 animate-spin text-slate-400" /></div>;

  const cards = [
    ["Total Customers", d.total_customers, Users, "blue"],
    ["Active Subscriptions", d.active_subscriptions, CreditCard, "emerald"],
    ["Trial Users", d.trial_users, FlaskConical, "amber"],
    ["MRR", `£${d.mrr.toLocaleString()}`, TrendingUp, "violet"],
    ["AI Receptionists Active", d.ai_active, Bot, "blue"],
    ["Calls Answered Today", d.calls_today, PhoneCall, "emerald"],
    ["Total AI Minutes Used", d.total_minutes.toLocaleString(), Clock, "slate"],
    ["Appointments Booked", d.appointments, CalendarCheck, "violet"],
    ["Messages Captured", d.messages, MessageSquare, "amber"],
    ["New Customers This Month", d.new_this_month, UserPlus, "rose"],
  ];
  const pie = (d.plan_distribution || []).filter((p) => p.value > 0);

  return (
    <div data-testid="admin-overview">
      <h1 className="font-heading text-2xl font-bold tracking-tight">Platform Overview</h1>
      <p className="text-slate-500 mt-1 text-sm">Your OperaMind control centre at a glance.</p>
      <div className="mt-6 grid grid-cols-2 lg:grid-cols-5 gap-4">
        {cards.map(([label, value, icon, accent], i) => (
          <StatCard key={label} testid={`stat-${i}`} label={label} value={value} icon={icon} accent={accent} />
        ))}
      </div>
      <div className="mt-6 grid lg:grid-cols-2 gap-4">
        <div className="rounded-xl border border-slate-200 bg-white p-6">
          <h2 className="font-heading font-bold tracking-tight mb-4">Active plan distribution</h2>
          {pie.length ? (
            <ResponsiveContainer width="100%" height={260}>
              <PieChart>
                <Pie data={pie} dataKey="value" nameKey="name" cx="50%" cy="50%" outerRadius={90} label>
                  {pie.map((e, i) => <Cell key={i} fill={CHART_COLORS[i % CHART_COLORS.length]} />)}
                </Pie>
                <Tooltip /><Legend />
              </PieChart>
            </ResponsiveContainer>
          ) : <p className="text-sm text-slate-400 py-16 text-center">No active subscriptions yet.</p>}
        </div>
        <div className="rounded-xl border border-slate-200 bg-white p-6">
          <h2 className="font-heading font-bold tracking-tight mb-4">Revenue snapshot</h2>
          <div className="space-y-4">
            <div className="flex justify-between items-center"><span className="text-slate-500">Monthly Recurring Revenue</span><span className="font-heading text-xl font-bold">£{d.mrr.toLocaleString()}</span></div>
            <div className="flex justify-between items-center"><span className="text-slate-500">Annualised (ARR)</span><span className="font-heading text-xl font-bold">£{(d.mrr * 12).toLocaleString()}</span></div>
            <div className="flex justify-between items-center"><span className="text-slate-500">Trial → Paid opportunity</span><span className="font-semibold text-blue-600">{d.trial_users} trials</span></div>
          </div>
        </div>
      </div>
    </div>
  );
}
